import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";
import "./style/global.less";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { createStore } from "redux";
import { Provider } from "react-redux";
import zhCN from "@arco-design/web-react/es/locale/zh-CN";
import enUS from "@arco-design/web-react/es/locale/en-US";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import request from "@/utils/request";
import rootReducer from "./store";
import PageLayout from "./layout";
import { GlobalContext } from "./context";
import Login from "./pages/login";
import checkLogin from "./utils/checkLogin";
import changeTheme from "./utils/changeTheme";
import useStorage from "./utils/useStorage";
import "./mock";
import { normalizePermissions } from "./utils/permissions";
const store = createStore(rootReducer);

function Index() {
  const [lang, setLang] = useStorage("arco-lang", "zh-CN");
  const [theme, setTheme] = useStorage("arco-theme", "light");

  function getArcoLocale() {
    switch (lang) {
      case "zh-CN":
        return zhCN;

      case "en-US":
        return enUS;

      default:
        return zhCN;
    }
  }

  const fetchUserInfo = async () => {
    store.dispatch({
      type: "update-userInfo",
      payload: {
        userLoading: true
      }
    });

    try {
      const response = await request.get("/admin/info");

      if (response.code !== 200 || !response.data) {
        throw new Error(response.message || "获取用户信息失败");
      }

      const permissions = normalizePermissions(response.data.permissionList || response.data.authorities);
      store.dispatch({
        type: "update-userInfo",
        payload: {
          userInfo: { ...response.data,
            permissions
          },
          userLoading: false
        }
      });
    } catch (error) {
      store.dispatch({
        type: "update-userInfo",
        payload: {
          userLoading: false
        }
      });
    }
  };

  const fetchMenus = async () => {
    store.dispatch({
      type: "update-menus",
      payload: {
        menuLoading: true
      }
    });

    try {
      const response = await request.get("/menu/getList");

      if (response.code !== 200 || !response.data) {
        throw new Error(response.message || "获取菜单失败");
      }

      store.dispatch({
        type: "update-menus",
        payload: {
          menus: response.data,
          menuLoading: false
        }
      });
    } catch (error) {
      store.dispatch({
        type: "update-menus",
        payload: {
          menuLoading: false
        }
      });
    }
  };

  useEffect(() => {
    if (checkLogin()) {
      fetchUserInfo();
      fetchMenus();
    } else if (window.location.pathname.replace(/\//g, "") !== "login") {
      window.location.pathname = "/login";
    }
  }, []);
  useEffect(() => {
    changeTheme(theme);
  }, [theme]);
  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme
  };
  return /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(_ConfigProvider, {
    locale: getArcoLocale(),
    componentConfig: {
      Card: {
        bordered: false
      },
      List: {
        bordered: false
      },
      Table: {
        border: false
      }
    }
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(GlobalContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: PageLayout
  }))))));
}

ReactDOM.render( /*#__PURE__*/React.createElement(Index, null), document.getElementById("root"));